{
  "dropzoneLabel": "DropZone",
  "selectPlaceholder": "Izberite element",
  "tableResizer": "Spreminjanje velikosti",
  "expand": "Expand",
  "collapse": "Collapse",
  "colorSwatchPicker": "Color swatches"
}
